<template>
  <v-container
    class="main--text"
    fluid>
    <v-row
      justify=center>
      <v-col
        cols=12
        md=8>
        <v-card>
          <v-container
            fluid>
            <dl
              class="question-and-answer">
              <dt>Q体験にはどのようなものが必要ですか？</dt>
              <dd>
                Aご自宅のPCに関し、以下の項目をご確認ください。
                <ul>
                  <li>マイク機能の有無</li>
                  <li>カメラ機能の有無</li>
                </ul>
                また対応ブラウザは、以下のいずれかの最新版のみ動作を保証しております。
                <ul>
                  <li>Google Chrome</li>
                  <li>Firefox</li>
                  <li>Safari</li>
                </ul>
                ご自宅の環境で受講可能かどうかご不安な場合は、一度LINE@からお問い合わせいただけますと幸いです。
              </dd>
            </dl>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      justify=center>
      <v-col
        cols=12
        md=8>
        <v-card>
          <v-container
            fluid>
            <dl
              class="question-and-answer">
              <dt>Qどのようなことを勉強するのでしょうか？</dt>
              <dd>
                Aプログラミング言語の学習を中心に、ITに関する知識を学ぶことができます。<br>
                現在対応している言語は以下の通りです。
                <ul>
                  <li><b>JavaScript</b></li>
                  <li><b>Python3</b></li>
                </ul>
                コンピュータ・Webの知識は、現代社会において必要不可欠なものであり、それを学ぶ上で非常に重要なのがプログラミングです。<br>
                実際の授業では、お子さまの関心・理解度に応じて柔軟に、一つ一つ丁寧に授業を進めていきます。
              </dd>
            </dl>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      justify=center>
      <v-col
        cols=12
        md=8>
        <v-card>
          <v-container
            fluid>
            <dl
              class="question-and-answer">
              <dt>Q対象年齢は何歳から何歳までですか？</dt>
              <dd>
                A小学生から高校生までの、幅広い年齢層のお子さまにご受講いただけます。<br>
                本格的なテキストプログラミングは、『Scratch』などのビジュアルプログラミングと比べて難しいと言われますが、小学校中・高学年以上であれば、じっくりと学ぶことで十分に身につけることができます。
              </dd>
            </dl>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      justify=center>
      <v-col
        cols=12
        md=8>
        <v-card>
          <v-container
            fluid>
            <dl
              class="question-and-answer">
              <dt>Q授業料・入会金等の費用が知りたいです。</dt>
              <dd>
                A入会金および教材費等は不要です。<br><br>
                授業料:<br>
                <b>１回あたり4,980円(税別)</b><br><br>
                授業は60分で、ご希望に応じた回数受講できます。
              </dd>
            </dl>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  
}
</script>

<style scoped>

.question-and-answer {
  margin: 10px;
  line-height: 1.6rem;
  overflow: hidden;
  _zoom: 1;
}

.question-and-answer dd,
.question-and-answer dt {
  text-indent: -2.0rem;
  padding: 0 20px 0px 50px;
}

.question-and-answer dt {
  margin: 20px 20px 0 0;
  font-size: 1.3rem;
  font-weight: bold
}

.question-and-answer dd::first-letter,
.question-and-answer dt::first-letter {
  font-size: 1.6rem;
  font-weight: bold;
  margin-right: 5px;
  padding: 5px;
}

.question-and-answer dd {
  margin: 20px 0 -1px 0;
  padding-bottom: 15px;
  border-bottom: 1px #000 dotted;
  font-size: 1.0rem;
}

.question-and-answer dt::first-letter {
  color: #0f78e1;
}
.question-and-answer dd::first-letter {
  color: #ff6767;
}

.question-and-answer ul {
  margin: 10px 0px 10px 30px;
  list-style: none;
}
</style>
